import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

interface Props {
  product: string | null;
  total: number;
  unit: string | null;
  totalDosageLeft?: number | null;
  totalAllowed?: number | null;
}

const TotalDoseDisplay = ({
  product,
  totalAllowed,
  unit,
  totalDosageLeft,
  total,
}: Props) => {
  return (
    <Stack direction="row" gap={1}>
      <Typography
        fontWeight={600}
        color={
          totalAllowed == null
            ? "inherit"
            : total >= totalAllowed
            ? "success"
            : "error"
        }
      >
        {product}:{" "}
        {`${total} ${totalAllowed != null ? `/ ${totalAllowed}` : ""} ${unit}`}
      </Typography>
      {totalDosageLeft != null ? (
        <Typography
          color={totalDosageLeft >= 0 ? "success" : "error"}
        >{`(${totalDosageLeft} ${unit} left)`}</Typography>
      ) : null}
    </Stack>
  );
};

export default TotalDoseDisplay;
